import { PlatformNavigation } from '@datassential/platform-ui-lib';
import { FC, ReactNode, useCallback, useState } from 'react';
import cn from 'classnames';
import { Helmet } from 'react-helmet-async';
import Scrollbar from '../Scrollbar/Scrollbar';
import PlatformHeader from './PlatformHeader';
import './Page.styles.scss';
import { BreakpointsEnum, useMediaQuery } from '../../core/hooks/useMediaQuery';

interface IProps {
    title: string;
    children: ReactNode;
    isShownStickyFooter?: boolean;
    onScroll?: (scrollTop: number) => void;
    isResponsive?: boolean;
}

const Page: FC<IProps> = ({ children, title, isShownStickyFooter, onScroll, isResponsive = true }) => {
    const [scrollTop, setScrollTop] = useState(0);

    const isMobile = useMediaQuery(BreakpointsEnum.SM);

    const handleScroll = useCallback(
        (values: any) => {
            setScrollTop(values.scrollTop);
            onScroll?.(values.scrollTop);
        },
        [onScroll]
    );

    return (
        <div className="Page">
            <Scrollbar isShownStickyFooter={isShownStickyFooter} onScrollFrame={handleScroll} id="page-scrollbar">
                <Helmet title={`Report Pro by Datassential${title === '' ? '' : ' | '}${title}`} />
                {!isMobile && (
                    <>
                        <PlatformNavigation />
                        <PlatformHeader />
                    </>
                )}
                <div className={cn('Page__wrapper', { 'is-responsive': isResponsive })} data-scroll-top={scrollTop}>
                    {children}
                </div>
            </Scrollbar>
        </div>
    );
};

export default Page;
